import {
  fetchLessonClassStudentMeeting,
  fetchLessonClassStudentMeetingFilters,
} from "classroom/api/teacher";
import type { FilterResource } from "api/generated";
import type { MeetingMyLessonGroupsOverview } from "meetings/student-meeting/types";
import { defineStore } from "pinia";

export const useClassroomLessonClassStudentMeetingStore = defineStore(
  "classroomLessonClassStudentMeeting",
  () => {
    const loadStudentMeeting = async (
      lessonClass: string,
      params: Record<string, string> = {},
      signal?: AbortSignal,
    ): Promise<MeetingMyLessonGroupsOverview> => {
      return fetchLessonClassStudentMeeting(lessonClass, params, signal);
    };

    const loadStudentMeetingFilters = async (
      lessonClass: string,
      signal?: AbortSignal,
    ): Promise<FilterResource[]> => {
      return fetchLessonClassStudentMeetingFilters(lessonClass, signal);
    };

    return { loadStudentMeeting, loadStudentMeetingFilters };
  },
);
